// src/pages/monitoring/utils.js
import { useEffect, useState } from "react";

export const FALLBACK_SERVICES = ["backend"];

export function nsToDate(nsString) {
  const ns = Number(nsString);
  if (!Number.isFinite(ns)) return null;
  return new Date(ns / 1e6);
}

export function getMsg(r) {
  return r?.message ?? r?.line ?? "";
}

export function detectLevel(msg) {
  const m = (msg || "").toLowerCase();
  if (m.includes("fatal") || m.includes("panic")) return "FATAL";
  if (m.includes("error") || m.includes("exception") || m.includes("stacktrace")) return "ERROR";
  if (m.includes("warn")) return "WARN";
  if (m.includes("debug")) return "DEBUG";
  return "INFO";
}

export function levelStyles(level) {
  switch (level) {
    case "FATAL":
      return { bg: "rgba(220,38,38,0.18)", fg: "#b91c1c", border: "rgba(220,38,38,0.35)" };
    case "ERROR":
      return { bg: "rgba(220,38,38,0.14)", fg: "#dc2626", border: "rgba(220,38,38,0.28)" };
    case "WARN":
      return { bg: "rgba(217,119,6,0.14)", fg: "#b45309", border: "rgba(217,119,6,0.28)" };
    case "DEBUG":
      return { bg: "rgba(22,163,74,0.12)", fg: "#16a34a", border: "rgba(22,163,74,0.25)" };
    default:
      return { bg: "rgba(100, 116, 139, 0.12)", fg: "#475569", border: "rgba(100, 116, 139, 0.25)" };
  }
}

export function formatTime(d) {
  try {
    return d.toLocaleString();
  } catch {
    return String(d);
  }
}

export function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

export function useDebouncedValue(value, delayMs) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return v;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}

// ---- Performance formatters ----
export function fmtMs(x) {
  const n = Number(x || 0);
  if (!Number.isFinite(n)) return "—";
  if (n >= 1000) return `${(n / 1000).toFixed(2)}s`;
  return `${Math.round(n)}ms`;
}

export function fmtPct01(x) {
  const n = Number(x || 0);
  if (!Number.isFinite(n)) return "—";
  return `${Math.round(n * 100)}%`;
}

export function fmtBytes(x) {
  const n = Number(x || 0);
  if (!Number.isFinite(n) || n <= 0) return "—";
  const gb = n / (1024 ** 3);
  if (gb >= 1) return `${gb.toFixed(2)} GB`;
  const mb = n / (1024 ** 2);
  return `${mb.toFixed(0)} MB`;
}

export function healthColor({ p95Ms, cpuProcess, memRatio }) {
  const p95 = Number(p95Ms || 0);
  const cpu = Number(cpuProcess || 0);
  const mem = Number(memRatio || 0);

  if (p95 > 2000 || cpu > 0.95 || mem > 0.95) return "bad";
  if (p95 > 800 || cpu > 0.8 || mem > 0.85) return "warn";
  return "ok";
}
